import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class EquipmentDataFlowService {
    public showModal$ = new Subject<{type: ModalTypes, title: string, index: number}>();
    public onEdit$ = new Subject();
    public addCalibration$ = new Subject();
    public addRepair$ = new Subject();
}

export enum ModalTypes {
}
